<template>
  <div class="mobile-attention" id="mobile-attention">
    <header class="attention-header">
      <!-- <MobileNav /> -->

      <div class="attention-header__title">
        <img
          src="@/assets/image/attention/nav_icon_left.webp"
          alt="Decorative lightning bolt image"
          width="140"
          height="140"
          class="attention-header__dynamic attention-header__dynamic-cd"
        />
        <img
          src="@/assets/image/index/mobile_header_lightning.webp"
          alt="Decorative lightning bolt image"
          width="96"
          height="96"
          decoding="async"
          class="attention-header__dynamic attention-header__dynamic-lightning"
        />

        <img
          class="attention-header__title-img"
          src="@/assets/image/attention/mobile_title.webp"
          alt="Attention page title graphic"
          width="769"
          height="66"
          decoding="async"
          loading="lazy"
        />
      </div>

      <div class="mobile-marquee mobile-marquee--description">
        <div class="mobile-marquee-inner">
          <div class="mobile-marquee-track">
            <div
              v-for="dup in 2"
              :key="'mobile-marquee-banner-' + dup"
              class="mobile-marquee-group"
              :aria-hidden="dup === 2 ? 'true' : undefined"
            >
              <img
                v-for="item in 10"
                :key="`mobile-banner-${dup}-${item}`"
                class="mobile-marquee-title"
                src="@/assets/image/attention/header_footer_title.webp"
                width="200"
                height="14"
                alt="Scrolling footer title strip (decorative)"
                aria-hidden="true"
                decoding="async"
              />
            </div>
          </div>
        </div>
      </div>
    </header>

    <div class="mobile-attention__content mobile-business-fade-up">
      <div
        v-for="(item, index) in attentionSections"
        :key="'attention-section-' + index"
        class="mobile-attention__content-item"
        :class="{ 'is-row-open': openIndex === index }"
      >
        <div
          class="mobile-attention__content-item-title mobile-touch-press"
          :class="{ 'is-active': openIndex === index }"
          @click="openItem(index)"
        >
          <span>{{ item.title }}</span>
          <span
            class="mobile-attention__content-item-toggle"
            aria-hidden="true"
          >
            <img
              class="mobile-attention__content-item-toggle-img mobile-attention__content-item-toggle-img--open"
              src="@/assets/image/attention/open.webp"
              alt="Expand item"
              width="24"
              height="24"
            />
            <img
              class="mobile-attention__content-item-toggle-img mobile-attention__content-item-toggle-img--close"
              src="@/assets/image/attention/close.webp"
              alt="Collapse item"
              width="24"
              height="24"
            />
          </span>
        </div>
        <div
          class="mobile-attention__content-item-body"
          :class="{ 'is-open': openIndex === index }"
        >
          <div class="mobile-attention__content-item-body-inner">
            <div class="mobile-attention__content-item-content">
              <div
                v-for="(line, lineIdx) in item.content"
                :key="index + '-line-' + lineIdx"
                class="mobile-attention__content-item-content-item"
              >
                <template v-if="line === ''">
                  <br />
                </template>
                <template v-else-if="line.startsWith('・') || line.startsWith('※')">
                  <span class="mobile-attention__content-item-text hanging-indent" v-html="line"></span>
                </template>
                <template v-else>
                  <span class="mobile-attention__content-item-text" v-html="line"></span>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { scrollToAnchorById } from "@/utils/mobile-anchor";
import attentionContent from "@/views/data/attention-content.json";
import contentVisibility from "@/views/data/content-visibility.json";

/**
 * 移动端注意事项页：attention-content.json（与 PC attention 一致；正文行含「・」等标点，与 PC 同样直接输出）
 */
export default {
  name: "MAttention",
  data() {
    return {
      openIndex: null,
      attentionSectionsSource: attentionContent.attentionSections,
    };
  },
  computed: {
    attentionSections() {
      const all = this.attentionSectionsSource;
      const showLastTwo =
        contentVisibility.attention?.showAttentionSectionsLastTwo !==
        false;
      if (showLastTwo || all.length < 2) return all;
      return all.slice(0, all.length - 2);
    },
  },
  mounted() {
    this.$nextTick(() => {
      scrollToAnchorById("mobile-attention", {
        behavior: "auto",
        block: "start",
      });
    });
  },
  methods: {
    openItem(index) {
      this.openIndex = this.openIndex === index ? null : index;
    },
  },
};
</script>

<style scoped lang="scss">
.mobile-attention {
  color: #fff;
  font-family: "Noto Sans JP";

  position: relative;
  background-image: url("@/assets/image/streaming/mobile_bg.webp");
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: scroll;
  z-index: 0;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    top: 230px;
    width: 100%;
    height: 100%;
    background-image: url(@/assets/image/streaming/mobile_bg_icon.webp);
    background-position: top -30px left -30px; /* 保持你要的左上角对齐 */
    background-size: 140% auto;
    background-repeat: no-repeat;
    animation: BackgroundFloat 6s ease-in-out infinite;
    z-index: 1;
  }

  box-sizing: border-box;
  background-color: #3c3068;
  text-align: left;

  img {
    box-sizing: border-box;
    vertical-align: middle;
  }

  .attention-header {
    position: relative;
    width: 100%;
    box-sizing: border-box;

    &__background {
      position: absolute;

      width: 100%;
      object-fit: contain;
      object-position: center;
    }

    &__dynamic {
      position: absolute;
      object-fit: contain;
      object-position: center;
      transform-origin: center center;
      will-change: transform;
      animation: mobile-header-img-dynamic 1.35s infinite;

      position: absolute;
      z-index: 9;

      &-cd {
        top: 0px;
        left: -20px;
      }
      &-lightning {
        top: 90px;
        right: 30px;
      }
    }

    &__title {
      padding: 90px 88px 88px;
    }

    &__deco {
      position: absolute;
      object-fit: contain;
      object-position: center;
      transform-origin: center center;
      will-change: transform;
      animation: ticket-deco-beat 1.35s infinite;

      &-circular {
        top: 39px;
        left: 204px;
        width: 300px;
      }

      &-star {
        top: 71px;
        right: 188px;
        width: 227px;
      }
    }
  }

  &__content {
    position: relative;
    z-index: 10;
    padding: 80px 40px 108px;

    &-item {
      // margin: 0 auto 24px;
      margin-bottom: 16px;
      padding: 0 20px;
      // width: 1000px;
      width: 100%;
      background-color: #1c192b;
      border-radius: 8px;
      transition: box-shadow 0.3s ease;

      &.is-row-open {
        box-shadow: 0 0 0 1px rgba(255, 243, 128, 0.35),
          0 10px 28px rgba(0, 0, 0, 0.28);
      }

      &-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 0;
        cursor: pointer;
        user-select: none;
        -webkit-tap-highlight-color: transparent;

        color: #fff380;
        font-weight: 700;
        font-style: Bold;
        font-size: 18px;
        line-height: 150%;
        letter-spacing: 0%;
      }

      &-toggle {
        position: relative;
        flex-shrink: 0;
        width: 24px;
        height: 24px;
      }

      &-toggle-img {
        position: absolute;
        inset: 0;
        width: 24px;
        height: 24px;
        object-fit: contain;
        object-position: center;
        transition: opacity 0.3s ease,
          transform 0.35s cubic-bezier(0.33, 1, 0.32, 1);
      }

      &-toggle-img--close {
        opacity: 0;
        transform: rotate(-90deg) scale(0.85);
        pointer-events: none;
      }

      &-toggle-img--open {
        opacity: 1;
        transform: rotate(0deg) scale(1);
      }

      &-title.is-active {
        .mobile-attention__content-item-toggle-img--open {
          opacity: 0;
          transform: rotate(90deg) scale(0.85);
        }

        .mobile-attention__content-item-toggle-img--close {
          opacity: 1;
          transform: rotate(0deg) scale(1);
          pointer-events: none;
        }
      }

      &-body {
        display: grid;
        grid-template-rows: 0fr;
        transition: grid-template-rows 0.42s cubic-bezier(0.33, 1, 0.32, 1);

        &.is-open {
          grid-template-rows: 1fr;
        }
      }

      &-body-inner {
        overflow: hidden;
        min-height: 0;
      }

      /* 不叠 opacity：scoped 下嵌套选择器易匹配失败导致正文一直透明，仅靠 grid 收合即可 */
      &-content {
        padding: 10px 0 20px;
        font-family: "Noto Sans JP";
        font-size: 14px;
        font-weight: 400;
        line-height: 2;
        color: #fff;
        border-top: 1px dashed #fff;
      }

      &-content-item {
        display: flex;
        align-items: flex-start;

        &-bullet {
          flex-shrink: 0;
          margin-right: 8px;
        }

        &-text {
          flex: 1;
        }
      }

      @media (prefers-reduced-motion: reduce) {
        transition: none;

        &.is-row-open {
          box-shadow: 0 0 0 1px rgba(255, 243, 128, 0.28);
        }

        &-toggle-img {
          transition: none;
        }

        &-body {
          transition: none;
        }
      }
    }
  }
}

@keyframes mobile-attention-deco-beat {
  0%,
  42% {
    transform: scale(1);
    animation-timing-function: cubic-bezier(0.45, 0, 0.55, 1);
  }
  52% {
    transform: scale(0.9);
    animation-timing-function: cubic-bezier(0.55, 0.05, 0.6, 0.45);
  }
  58% {
    transform: scale(0.86);
    animation-timing-function: cubic-bezier(0.33, 1.15, 0.52, 1);
  }
  70% {
    transform: scale(1.08);
    animation-timing-function: cubic-bezier(0.22, 0.85, 0.38, 1);
  }
  80% {
    transform: scale(1);
    animation-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes mobile-attention-marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

/* 无限滚动横幅 */
.mobile-marquee {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 60px;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;

  background-image: url("@/assets/image/attention/header_footer_title_bg.webp");

  &--description {
    position: absolute;
    left: 0;
    right: 0;
    bottom: -28px;
    z-index: 9;
  }

  &-inner {
    width: 100%;
    height: 24px;
    overflow: hidden;
    background-color: #191616;
    display: flex;
    align-items: center;
    border-top: 2px solid #36e9ff;
    border-bottom: 2px solid #36e9ff;
  }

  &-track {
    display: flex;
    width: max-content;
    flex-shrink: 0;
    align-items: center;
    animation: mobile-marquee 30s linear infinite;
    will-change: transform;

    @media (prefers-reduced-motion: reduce) {
      animation: none;
      will-change: auto;
    }
  }

  &-group {
    display: flex;
    flex-shrink: 0;
    align-items: center;
  }

  &-title {
    flex-shrink: 0;
    margin-right: 20px;
    width: 200px;
    height: 10px;
    object-fit: contain;
    object-position: center;
  }
}

/* 无限滚动动画 */
@keyframes mobile-marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

@keyframes mobile-header-img-dynamic {
  0%,
  42% {
    transform: scale(1);
    animation-timing-function: cubic-bezier(0.45, 0, 0.55, 1);
  }
  52% {
    transform: scale(0.9);
    animation-timing-function: cubic-bezier(0.55, 0.05, 0.6, 0.45);
  }
  58% {
    transform: scale(0.86);
    animation-timing-function: cubic-bezier(0.33, 1.15, 0.52, 1);
  }
  70% {
    transform: scale(1.08);
    animation-timing-function: cubic-bezier(0.22, 0.85, 0.38, 1);
  }
  80% {
    transform: scale(1);
    animation-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes BackgroundFloat {
  0% {
    background-position: top -30px left -30px;
    background-size: 140% auto;
    opacity: 0.85;
  }

  50% {
    /* 中心对称放大 → 向四周扩散 */
    background-position: top -60px left -60px;
    background-size: 150% auto;
    opacity: 1;
  }

  100% {
    /* 回到初始位置 */
    background-position: top -30px left -30px;
    background-size: 140% auto;
    opacity: 0.85;
  }
}
</style>
